import {DocumentNode, gql} from "@apollo/client";

export const NOTIFICATION_SETTING_QUERY: DocumentNode = gql(`    
    query GetNotificationSetting {
      getNotificationSetting {
        ...NotificationSetting
      }
    }
`);
